export const counties = [
  {
    value: "Bjelovarsko-bilogorska",
    label: "Bjelovarsko-bilogorska",
  },
  {
    value: "Brodsko-posavska",
    label: "Brodsko-posavska",
  },
  {
    value: "Dubrovačko-neretvanska",
    label: "Dubrovačko-neretvanska",
  },
  {
    value: "Grad Zagreb",
    label: "Grad Zagreb",
  },
  {
    value: "Istarska",
    label: "Istarska",
  },
  {
    value: "Karlovačka",
    label: "Karlovačka",
  },
  {
    value: "Koprivničko-križevačka",
    label: "Koprivničko-križevačka",
  },
  {
    value: "Krapinsko-zagorska",
    label: "Krapinsko-zagorska",
  },
  {
    value: "Ličko-senjska",
    label: "Ličko-senjska",
  },
  {
    value: "Međimurska",
    label: "Međimurska",
  },
  {
    value: "Osječko-baranjska",
    label: "Osječko-baranjska",
  },
  {
    value: "Požeško-slavonska",
    label: "Požeško-slavonska",
  },
  {
    value: "Primorsko-goranska",
    label: "Primorsko-goranska",
  },
  {
    value: "Šibensko-kninska",
    label: "Šibensko-kninska",
  },
  {
    value: "Sisačko-moslavačka",
    label: "Sisačko-moslavačka",
  },
  {
    value: "Splitsko-dalmatinska",
    label: "Splitsko-dalmatinska",
  },
  {
    value: "Varaždinska",
    label: "Varaždinska",
  },
  {
    value: "Virovitičko-podravska",
    label: "Virovitičko-podravska",
  },
  {
    value: "Vukovarsko-srijemska",
    label: "Vukovarsko-srijemska",
  },
  {
    value: "Zadarska",
    label: "Zadarska",
  },
  {
    value: "Zagrebačka",
    label: "Zagrebačka",
  },
];
